export enum SliderType {
  RANGE = 'range',
  SIMPLE = 'simple'
}
